import { useNavigate } from "react-router-dom";
import { ROUTE_PATHS } from "src/config";
import { firebaseSignOut } from "src/config/firebase/firebase";
import { useAppDispatch } from "src/config/store/hooks";
import { logout } from "src/config/store/slices/auth/auth.slice";

export const useLogout = () => {
  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  const handleLogout = async () => {
    dispatch(logout());

    await firebaseSignOut();

    navigate(ROUTE_PATHS.LOGIN, { replace: true });
  };

  return { handleLogout };
};
